export interface GalleryFill {
  leadSpan: 1 | 2;
  visible: number;
}

export function galleryFill(count: number, columns: number): GalleryFill {
  const total = Math.max(0, Math.floor(count));
  const cols = Math.max(1, Math.floor(columns));
  if (total <= cols || total % cols === 0) return { leadSpan: 1, visible: total };
  if (cols > 1 && (total + 1) % cols === 0) return { leadSpan: 2, visible: total };
  const plain = total - (total % cols);
  const spanned = cols > 1 ? total - ((total + 1) % cols) : 0;
  return spanned > plain ? { leadSpan: 2, visible: spanned } : { leadSpan: 1, visible: plain };
}
